// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, CircularProgress } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { classNames } from '@shared/ui-kit/utils/classnames';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { useNavigationControls } from './use-navigation-controls';

export const NavigationControls = defineComponent({
  displayName: 'NavigationControls',
  useSetup: useNavigationControls,
  View: props => {
    if (props.hidePrevious && props.hideNext) {
      return null;
    }

    return (
      <div className="shrink-0 border-t p-8">
        <div
          className={classNames(
            'mx-auto flex w-full max-w-4xl shrink-0 items-center',
            props.hidePrevious && !props.hideNext && 'justify-end',
            !props.hidePrevious && props.hideNext && 'justify-start',
            !props.hidePrevious && !props.hideNext && 'justify-between',
          )}
          data-testid="bank-upload-navigation-controls"
        >
          {!props.hidePrevious && (
            <Button
              variant="outlined"
              color="secondary"
              data-testid="previous-button"
              onClick={props.onPrevious}
              disabled={props.isPreviousDisabled || props.loading}
              size="large"
              startIcon={props.previousIcon ?? <AppIcon icon="ArrowLeft" />}
              type="button"
            >
              {props.previousLabel ?? (
                <Translation i18nKey="common.previous" ns="common" />
              )}
            </Button>
          )}

          {!props.hideNext && (
            <Button
              color="secondary"
              data-testid="next-button"
              onClick={props.form ? undefined : props.onNext}
              disabled={props.isNextDisabled || props.loading}
              size="large"
              endIcon={
                props.loading ? (
                  <CircularProgress size={16} color="secondary" />
                ) : (
                  props.nextIcon ?? <AppIcon icon="ArrowRight" />
                )
              }
              type={props.form ? 'submit' : 'button'}
              form={props.form}
            >
              {props.loading
                ? props.loadingLabel ?? (
                    <Translation i18nKey="common.saving" ns="common" />
                  )
                : props.nextLabel ?? (
                    <Translation i18nKey="common.continue" ns="common" />
                  )}
            </Button>
          )}
        </div>
      </div>
    );
  },
});
